const IMMUTABLE_SETTING =
  "You won't be able to change this setting after listing.";
export default IMMUTABLE_SETTING;
